import { render, staticRenderFns } from "./RegimenQuestionnaireEdit.vue?vue&type=template&id=60ed55e0"
import script from "./RegimenQuestionnaireEdit.vue?vue&type=script&lang=js"
export * from "./RegimenQuestionnaireEdit.vue?vue&type=script&lang=js"
import style0 from "./RegimenQuestionnaireEdit.vue?vue&type=style&index=0&id=60ed55e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports